import { ParamsUtil } from './params';

const isTestEnv = () => ParamsUtil.getParam('debug') === '1';

export default {
  base(type, ...value) {
    if (!isTestEnv()) {
      return;
    }
    if (type === 'log') {
      // eslint-disable-next-line no-console
      console.log('[platformH5]', ...value);
    } else if (type === 'warn') {
      // eslint-disable-next-line no-console
      console.warn('[platformH5]', ...value);
    }
  },
  log(...value) {
    this.base('log', ...value);
  },
  warn(...value) {
    this.base('warn', ...value);
  },
};
